<script>
  import { messageSuccess } from "@utils/message";
  import { globalComputed, authComputed } from "@store/helpers";

  export default {
    data() {
      return {
        email: '',
        tryingSubscription: false,
      }
    },
        computed: {
      ...globalComputed,
      // ...authComputed,
      invalid() {
        return !(/^\S+@\S+\.\S+/.test(this.email))
      },
      foramtLineId() {
        return (this.currentSetting.lineId || '').replace('@', '')
      },
      subscriptionTitle() {
        // 關注零壹Facebook粉絲專頁、LINE官方帳號、訂閱 Podcast & Youtube 頻道，掌握最新消息不漏接！
        const map = [
          this.currentSetting.fbFanpageUrl ? 'Facebook粉絲專頁' : '',
          this.currentSetting.lineId ? 'LINE官方帳號' : '',
        ]
          .filter(item => {
            return item
          })
          .join('、')
            
        const map2 = [
          this.currentSetting.podcast ? 'Podcast' : '',
          this.currentSetting.youtubeUrl ? 'Youtube' : ''
        ]
          .filter(item => {
            return item
          })
          .join('＆')

        return `${map ? `關注零壹${map}`: '' } ${map && map2 ? '、' : ''} ${map2 ? `訂閱${map2}頻道` : ''}`
        // return map ? `關注零壹${map}` : '' + (map&&map2) ? '、' : '' + map2 ? `訂閱 ${map2} 頻道`: ''
      }
    },
    mounted() {

    },
    methods: {
      async onSubscription() {
        this.tryingSubscription = true;

        await this.$store.dispatch("global/subscribe", {
          email: this.email,
          subscribeNewsletter: 1
        })
          .then(() => {
            this.tryingSubscription = false;

            messageSuccess('已成功訂閱！');
          });
      },
    }
  }
</script>

<template>
  <section class="section ">
    <h2 class="Home-title"
    ><span class="Home-title__small">IT情報隨時接收</span>
      <span class="Home-title__big pb-4">訂閱零壹最新消息</span>
    </h2>
    <div :class="$style.subscription" class="container">
      <div class="row">
        <div
          class="subscription__left subscription__item"
          :class="!!currentSetting.fbFanpageUrl || !!foramtLineId ? 'col-xl-6 ' : 'col-xl-12 text-center'"
        >
          <div class="subscription__box">
            <!-- <BaseSectionTitle2 title="歡迎訂閱" /> -->
            <div class="subscription__box__title text-center">訂閱零壹快訊</div>
            <p class="text-gray-6 mt-5">提供您最新優惠、課程活動資訊，讓您不錯過重要資訊，掌握第一手消息！</p>
            <el-form
              v-model="email"
              @submit.prevent.native="onSubscription"
              class="subscription__form d-inline-block"
            >
              <div class="d-flex">
                <div style="width: 100%;">
                  <BaseEmail
                    v-model="email"
                    class="isStyleSubscription"
                    placeholder="輸入您的電子郵件"
                  />
                </div>
                <div>
                  <BaseButton
                    type="submit"
                    class="isStylePrimary isFull subscription__submit"
                    :disabled="invalid || tryingSubscription"
                  >
                    訂閱
                  </BaseButton>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div
          v-if="!!currentSetting.fbFanpageUrl || !!foramtLineId"
          class="col-xl-6 subscription__right subscription__item"
        >
          <div class="subscription__box">
            <div class="subscription__box__title text-center">關注零壹</div>
            <p class="text-gray-6 mt-5">{{ subscriptionTitle }}，掌握最新消息不漏接！</p>
            <div class="socialMenu text-center">
              <a
                v-if="currentSetting.fbFanpageUrl"
                :href="currentSetting.fbFanpageUrl"
                target="_blank"
                class="text-decoration-none socialMenu__item"
              >
                <i class="fab fa-facebook-square"></i>
                <span class="sr-only">facebook</span>
              </a>
              <a
                v-if="foramtLineId"
                :href="`https://line.me/R/ti/p/%40${foramtLineId}`"
                target="_blank"
                class="text-decoration-none socialMenu__item"
              >
                <i class="fab fa-line"></i>
                <span class="sr-only">line</span>
              </a>
              <a
                v-if="currentSetting.podcast"
                :href="currentSetting.podcast"
                target="_blank"
                class="text-decoration-none socialMenu__item"
              >
                <i class="far fa-podcast"></i>
                <span class="sr-only">podcast</span>
              </a>
              <a
                v-if="currentSetting.youtubeUrl"
                :href="currentSetting.youtubeUrl"
                target="_blank"
                class="text-decoration-none socialMenu__item"
              >
                <i class="fab fa-youtube"></i>
                <span class="sr-only">youtube</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" module>
  .SectionSubscription {
  }

  .subscription {
    // display: flex;
    @media screen and (max-width: 1200px) {
      text-align: center;
    }

    @include max-lg {
      flex-direction: column;
      height: auto;
    }

    p {
      margin-bottom: 40px;
      //  max-width: 534px;
      font-size: 1.25rem;
      line-height: 1.75;

      @include max-lg {
        margin-bottom: 1.5rem;
        font-size: 1rem;
      }
    }

    :global {
      .subscription {
        &__left {
          padding-right: 7.0625rem;

          @media screen and (max-width: 1200px) {
            padding-right: 19px;
          }
        }

        &__right {
          padding-left: 7.0625rem;

          @media screen and (max-width: 1200px) {
            padding-left: 19px;
          }
        }

        &__box {
          &__title {
            position: relative;
            font-size: 1.5rem;
            font-weight: medium;
            color: $color-gray-7;

            &::before {
              position: absolute;
              right: 0;
              bottom: -10px;
              left: 50%;
              width: 30px;
              height: 5px;
              content: '';
              background: $color-primary;
              border-radius: 3px;
              transform: translateX(-50%);
            }
          }
        }

        &__form {
          max-width: 534px;
          border-radius: 5px;
          box-shadow: 3px 10px 15px rgba(33, 69, 88, 0.1);
        }

        &__submit {
          padding: 1.75rem 4.92rem;
          font-size: 1.125rem;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;

          @include max-md {
            padding: 1rem 1.5rem;
          }
        }

        &__item {
          &:not(:last-child) {
            border-right: 2px solid $color-gray-2;

            @media screen and (max-width: 1200px) {
              margin-bottom: 3rem;
            }
          }
        }
      }
    }
  }
</style>
